import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

const storageKey = 'accessToken';

function readToken(): string | null {
  try {
    return localStorage.getItem(storageKey);
  } catch {
    return null;
  }
}

function writeToken(accessToken: string): void {
  try {
    localStorage.setItem(storageKey, accessToken);
  } catch {}
}

interface AuthState {
  accessToken: string | null;
}

export const AuthStore = signalStore(
  { providedIn: 'root' },
  withState<AuthState>(() => ({ accessToken: readToken() })),
  withMethods((store) => ({
    setToken(accessToken: string) {
      writeToken(accessToken);
      patchState(store, { accessToken });
    },
  })),
);
